

<template>
  <div>
    <!--    Breadcrumb Section Component-->
    <breadcrumb :breadcrumb="breadcrumb"/>
    <!--    Gallery Section Component-->
    <gallery-area/>
  </div>
</template>
<script>
import Breadcrumb from "../components/Breadcrumb";
import GalleryArea from "../components/GalleryArea";

export default {
  name: 'Gallery',
  components: {GalleryArea, Breadcrumb},
  data() {
    return {
      breadcrumb: {
        title: 'Our Gallery',
        link: 'Gallery'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Gallery.vue